import { Chart as ChartJS, registerables } from 'chart.js';
import React from 'react';
import { Pie } from 'react-chartjs-2';
import { StatsEntity } from '../../../../domain/stats';
import { TransportOrderStatus } from '../../../../domain/transportOrder';

ChartJS.register(...registerables);

type TransportOrdersByStatusStatsProps = {
    transportOrdersStatusesStats: StatsEntity['transportOrdersStatusStats'];
};

const statusLabels: { [key in TransportOrderStatus]: string } = {
    DRAFT: 'Szkic',
    CREATED: 'W Trakcie',
    LOADED: 'Załadowane',
    UNLOADED: 'Rozładowane',
    DONE: 'Zakończone',
    STORNO: 'Storno',
}

const statusOrder: Array<TransportOrderStatus> = [
    'DONE',
    'UNLOADED',
    'LOADED',
    'CREATED',
    'STORNO',
    'DRAFT',
];

export const TransportOrdersByStatusStats = ({ transportOrdersStatusesStats }: TransportOrdersByStatusStatsProps) => {
    const numberOfNoDrafts = Object.entries(transportOrdersStatusesStats).filter(([status]) => status !== 'DRAFT')
        .map(([_, count]) => (count))
        .reduce((acc, next) => acc + next, 0);

    const data = {
        labels: statusOrder.map((status) => statusLabels[status]),
        datasets: [
            {
                label: '# Zleceń',
                data: statusOrder.map((status) => transportOrdersStatusesStats[status]),
                backgroundColor: [
                    'rgb(13, 110, 253, .9)', // Color for DONE
                    'rgb(25, 135, 84, .9)', // Color for UNLOADED
                    'rgb(255, 193, 7, .9)', // Color for LOADED
                    'rgb(13, 202, 240, .9)',  // Color for CREATED
                    'rgb(220, 53, 69, .9)',  // Color for storno
                    'rgb(108, 117, 125, .9)',  // Color for DRAFT
                ],
                borderColor: [
                    'rgba(75, 192, 192, 1)',
                    'rgba(54, 162, 235, 1)',
                    'rgba(153, 102, 255, 1)',
                    'rgba(255, 206, 86, 1)',
                    'rgba(255, 99, 132, 1)',
                ],
                borderWidth: 1,
            },
        ],
    };
    const options = {
        plugins: {
            legend: {
                position: 'bottom',
                labels: {
                    boxWidth: 20,
                    padding: 10,
                    maxWidth: 200, // <-- to ograniczy szerokość i wymusi zawijanie
                },
            },
        },
    };

    return <>
        <h5 className="m-0">{numberOfNoDrafts} zleceń</h5>
        {/*@ts-ignore*/}
        <Pie data={data} options={options} />
        <ul className="list-unstyled">
            {statusOrder.map((status) => <li key={status}><b>{statusLabels[status]}</b>: {transportOrdersStatusesStats[status]}</li>)}
        </ul>
    </>;
};